/**
 * dev  : zhihuaw
 * desc : 榜单聚合页model层组件
 * props: compProps、payLoad、compIndex
 * emit : init：初始化数据；finish：数据改变触发
 */
<template>
  <div></div>
</template>
<script>
/* eslint-disable */
import { qFetchHouseIds, qFetchHouseDetail, qFetchFocus, qCheckFavorite, qFetchFavorite } from '@/services/q_toplist'
import { Sniff } from '@/utils/q_sniff'
import { openScheme, getFromForLog } from '@/utils/q_business'

export default {
  components: {
  },
  data() {
    return {
      // 榜单中房屋数据
      houseData: [],
      // 房屋收藏关注数和状态
      // favorFocus: null,
      // 防止重复点击收藏
      // isClick: false,
    }
  },
  props: {
    /**
     * [detail主接口comProps属性数据]
     */
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * [组件所需数据体]
     */
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * [组件索引]
     */
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    /**
     * [payload改变]
     * TODO: 调用收藏接口/去往cms详情页
     */
    payLoad(newVal){
      if(newVal.type==='location'){
        this.gotoDetail(newVal.data)
      }
    }
  },
  methods: {
    /**
     * [榜单初始化方法]
     */
    async init() {
      // 通过榜单id获取房屋id，
      const ids = [this.compProps.mate.activityId]
      const labelRes = await qFetchHouseIds({ ids })
      const labelData = labelRes.value || {}
      if (labelData.ret && labelData.data) {
        this.houseData = labelData.data[0].houseData
        
        try{
          const houseIdList=[]

          this.houseData.forEach((item,index) => {
            // 只查询cms榜单中的前10个房屋详情（查询太多，时效太长）
            if(index <= 1){
              houseIdList.push(item.id)
            }
          })
          // 无需报价
          const noNeedPrice = true
          // 展示下架房屋
          const needUnactive = true
          // 展示无库存
          const needNoRepositoty = true
          // 通过房屋id获取房屋详情
          const houseRes = await qFetchHouseDetail({ houseIdList, noNeedPrice, needUnactive, needNoRepositoty })
          const houseData = houseRes.value || {}
          
          if (houseData.ret && houseData.data) {
            const houseList = houseData.data.items
            
            houseList.forEach((item,index)=>{
              const idx = houseIdList.indexOf(item.unitId.toString())
              
              if (idx > -1) {
                this.houseData[idx].defaultPicture = item.pictureList ? item.pictureList[0] : item.defaultPicture
                this.houseData[idx].unitName = item.unitName
              }
            })
          }
          this.$emit('init',this.houseData)
          // 检查房屋收藏状态，不必优先请求
          // this.checkFavorAndFocus()
        } catch (e) {
          console.log(e)
        }
      }
    },
    /**
     * [榜单收藏状态和关注数接口方法]
     */
    // checkFavorAndFocus() {
    //   // 通过榜单id获取房屋id，
    //   const activityId = this.compProps.mate.activityId
    //   const activityIdList = [activityId]
    //   const favoriteItemType = 5
    //   const virtureType = 1
    //   let fetchFavor = null

    //   // 宫格榜单一期不做收藏 所以这里先注掉
    //   // if(!Sniff.isLogin()){
    //   //   fetchFavor = Promise.resolve(false)
    //   // }else{
    //   //   fetchFavor = qCheckFavorite({activityIdList}).then((ret) => {
    //   //     if (ret && ret.errcode === 0) {
    //   //       if (ret.data.favoritedActivitys && ret.data.favoritedActivitys.length > 0) {
    //   //         return true
    //   //       } else {
    //   //         return false
    //   //       }
    //   //     } else {
    //   //       return false
    //   //     }
    //   //   })
    //   //   .catch((err) => {})
    //   // }
      
    //   const getFocus = qFetchFocus({activityIdList, favoriteItemType, virtureType}).then((ret) => {
    //     const res = ret.value
    //     if (res && res.errcode === 0) {
    //       const result = {}
    //       if (res.data.mapCount) {
    //         result.favorCount = res.data.mapCount[activityId]
    //       } else {
    //         result.favorCount = 0
    //       }
    //       if (res.data.attentionCount) {
    //         result.focusCount = res.data.attentionCount[activityId]
    //       }else {
    //         result.focusCount = 0
    //       }
    //       return result
    //     } else {
    //       return {favorCount: 0, focusCount: 0}
    //     }
    //   })
    //   .catch((err) => {})

    //   Promise.all([getFocus])
    //   .then((data) => {
    //     this.favorFocus = data[0] || { favorCount:0, focusCount:0 }
    //     // this.favorFocus.favorState = data[0]  这是收藏 q榜单一期先不做 所以注掉
    //   })
    //   .catch((e) => {
    //     this.favorFocus.favorState = false
    //     this.favorFocus.focusCount = 0
    //     this.favorFocus.favorCount = 0
    //   })
    //   .finally(() => {
    //     this.$emit('finish', this.favorFocus)
    //   })
    // },
    /**
     * [去往cms详情页]
     * @param val 关于cmsid，like的数据集合
     */
    gotoDetail (val) {
      const fromForLog = getFromForLog()
      const jumpUrl = `${window.location.origin}${window.location.pathname}?id=${val.activityId}&fromForLog=${fromForLog}`
      const title = val.activityTitle
      if (Sniff.qunar) {
        openScheme(jumpUrl, 'navibar-normal', title)
        return
      }
      if (Sniff.miniprogram) {
        openScheme(jumpUrl)
        return
      }
      window.location.href = jumpUrl
    },
    // 透传子servComp组件finish事件到UiComp组件
    finishHandle (payLoad) {
      this.$emit('finish', payLoad);
    }
  }
}
</script>
